import { WELCOME_HEADER } from 'constants/app.constant';
import CentralizedLandingPageCards from 'components/features/centralized-landing-page/centralized-landing-page-cards/CentralizedLandingPageCards';
import { DP_PILLS, PS_PILLS } from 'reports/ps/constants/ui.constant';
import NavigationCard from './NavigationCard';
export var ProgramSolutionsNavMenu = function (_a) {
    var PS = _a.PS, DP = _a.DP, onClickOutSide = _a.onClickOutSide;
    var handleOnNavigation = function (config) {
        if (!config.disabled) {
            config.onNavigation();
            onClickOutSide();
        }
    };
    return (<div className="c-ps-nav-menu">
      <div className="c-ps-nav-menu__header-container">
        <div className="c-ps-nav-menu__header-image c-ps-nav-menu__header-image--left"/>
        <div className="c-ps-nav-menu__header-title-container">
          <p className="c-ps-nav-menu__header-title">{WELCOME_HEADER}</p>
          <p className="c-ps-nav-menu__header-subtitle u-els-font-size-base">Your hub for essential performance analytics dashboards for Sherpath, HESI and Shadow Health</p>
        </div>
        <div className="c-ps-nav-menu__header-image c-ps-nav-menu__header-image--right"/>
      </div>

      <div className="c-ps-nav-menu__card-row-container">
        <NavigationCard item={DP} titleKey="DP" description="Track the progress of your institution, campus, programs and beyond towards practice readiness and NCLEX success." pills={DP_PILLS} onNavigate={handleOnNavigation}/>
        <NavigationCard item={PS} titleKey="PS" description="A holistic view of the nursing education journey, synthesizing insights from Sherpath, HESI, and Shadow Health to drive both program and student success." pills={PS_PILLS} onNavigate={handleOnNavigation}/>
      </div>

      <CentralizedLandingPageCards onClickOutSide={onClickOutSide}/>
    </div>);
};
